import type { BrowserHistory } from '@remix-run/router/history';
import type { IHistoryAction } from './interface';

function action(history: BrowserHistory | undefined): IHistoryAction {
    return {
        go: (count: number) => history?.go(count),
        goBack: () => history?.go(-1),
        goForward: () => history?.go(1),
        push: (path: string) => history?.push(path),
        replace: (path: string) => history?.replace(path),
    };
}

export default action;
